import axios from "axios";
import { BASE_URL } from "./Constants";

const instance = axios.create({
  withCredentials: true,
  baseURL: BASE_URL,
});

export async function getCollectionDetails(uidCollection) {
  try {
    const response = await instance.get(`/collection/${uidCollection}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllCollection() {
  try {
    const response = await instance.get(`/collection`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSerieDetails(idSerie) {
  try {
    const response = await instance.get(`/serie/${idSerie}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getFile(uidFile) {
  try {
    const response = await instance.get(`/doc/${uidFile}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAddCollection() {
  try {
    const response = await instance.get(`/collection/add`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAddSerie() {
  try {
    const response = await instance.get(`/serie/add`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getSerieUpdate(uidSerie) {
  try {
    const response = await instance.get(`/serie/${uidSerie}/cover`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAddEpisode(idSerie) {
  try {
    const response = await instance.get(`/episode/add?idSerie=${idSerie}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getAllGenre() {
  try {
    const response = await instance.get(`/genre`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getHomePage(classification) {
  try {
    const response = await instance.get(`/library`, {
      params: { classification },
    });
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export async function getNextRelease() {
  try {
    const response = await instance.get(`/home/release`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
}


export async function getSerieCode() {
  try {
    const response = await instance.get(`/manage/code/serie`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response.data;
  }
}

export async function getInvalidateCache() {
  try {
    const response = await instance.get(`${BASE_URL}/library/cache/invalidate`);
    return response;
  } catch (error) {
    console.error("erre", error);
  }
}

export async function getTransitionPlatforms() {
  try {
    const response = await instance.get(`/edifice/transition/platforms`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: 'Impossible de charger les plateformes' };
  }
}

export async function getTransitionJob(jobId) {
  try {
    const response = await instance.get(`/edifice/transition/${jobId}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: 'Suivi de la transition indisponible' };
  }
}

export async function getWebappCodes() {
  try {
    const response = await instance.get(`/manage/webappcode`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: 'Impossible de charger les codes' };
  }
}

export async function getWebappCode(code) {
  try {
    const response = await instance.get(`/manage/webappcode/${encodeURIComponent(code)}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: 'Impossible de charger ce code' };
  }
}

export async function getCodeSerieTree(code, idSerie) {
  try {
    const response = await instance.get(`/manage/webappcode/${encodeURIComponent(code)}/serie/${idSerie}`);
    return response.data;
  } catch (error) {
    console.error(error);
    return error.response?.data ?? { error: 'Impossible de charger cette série' };
  }
}
